import React from "react";
import PropTypes from "prop-types";

const NON_UPLOADABLE_SERVICES = new Set([
  "nats", "nats-box", "mqtt", "nginx", "shuttle",
  "clickhouse", "prometheus", "loki", "promtail", "grafana",
]);

const DockerContainer = ({ container, handleShowContainerLogs, handleRestartContainer, handleUploadConfig }) => {
  const canUpload = !NON_UPLOADABLE_SERVICES.has(container.Service);

  return (
    <div className="container-card">
      <div className="container-header">
        <h4>{container.Service}</h4>
        <span className={`container-status status-${container.State}`}>{container.State}</span>
      </div>
      <div className="container-details">
        <div>
          <strong>Name:</strong> {container.Name}
        </div>
        <div>
          <strong>Status:</strong> {container.Status}
        </div>
        {container.Publishers && container.Publishers.length > 0 && (
          <div>
            <strong>Ports:</strong>{" "}
            {container.Publishers.map((p) => `${p.PublishedPort}→${p.TargetPort}`).join(", ")}
          </div>
        )}
      </div>
      <div className="container-actions">
        <button
          className="container-logs-btn"
          onClick={() => handleShowContainerLogs(container.Name)}
        >
          View Logs
        </button>
        {canUpload && (
          <button
            className="container-upload-btn"
            onClick={() => handleUploadConfig(container.Name)}
          >
            Upload
          </button>
        )}
        <button
          className="container-restart-btn"
          onClick={() => handleRestartContainer(container.Name)}
        >
          Restart
        </button>
      </div>
    </div>
  );
};

DockerContainer.propTypes = {
  container: PropTypes.object.isRequired,
  handleShowContainerLogs: PropTypes.func.isRequired,
  handleRestartContainer: PropTypes.func.isRequired,
  handleUploadConfig: PropTypes.func.isRequired,
};

export default DockerContainer;
